import Vue from 'vue'
import VueRouter from 'vue-router'
import panoramaHome from '../views/panoramaHome.vue'
import Home from "@/views/Home.vue";
import my from "@/views/my.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/panoramaHome',
        name: 'panoramaHome',
        component: panoramaHome
    }, {
        path: '/my',
        name: 'my',
        component: my
    },

]
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

//replace
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
    return VueRouterReplace.call(this, to).catch(err => err)
}
const router = new VueRouter({
    mode: 'hash', cache: false,
    routes
})

export default router
